import { Component } from '@angular/core';
import { bootstrapCheck2, bootstrapEye, bootstrapLightbulb } from '@ng-icons/bootstrap-icons';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ionCheckmark } from '@ng-icons/ionicons'

@Component({
  selector: 'app-about-us',
  imports: [ NgIcon ],
  templateUrl: './about-us.component.html',
  styles: ``,
  viewProviders: [provideIcons({ ionCheckmark, bootstrapCheck2, bootstrapEye, bootstrapLightbulb })],

})
export class AboutUsComponent {

}
